import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, 
{
  ACTION_BUTTON_TYPES as ABT, addActiveFn,
  pushToParams,
  pushWithRow,
  requestTo,
  withNewTitle,
}  from "../../../../components/action-buttons/ActionButtonGenerator";

import FormikForm from "../../../../components/crud/FormikForm";
import ListComponent from "../../../../components/list/ListComponent";
import TextArea from "../../../../components/form-fields/TextArea";
import ReactDatePicker from "../../../../components/form-fields/ReactDatePicker";
import { formatShortDate, formatTime } from "../../../../utils";
import CurrencyInput from "../../../../components/form-fields/CurrencyInput";
import NumberInput from "../../../../components/form-fields/NumberInput";
import { useTranslation } from "react-i18next";

export default function TimesSpent(props) {
  const [refreshList, setRefreshList] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [totalDay, setTotalDay] = useState("");
  const {t} = useTranslation();

  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepId: props.selectedRow.id,
      harcananDate: values.harcananDate,
      saatDakika: values.saatDakika,
      aciklama: values.aciklama,
    };
    return payload;
  };

  const mapDataBeforeList = (row) => {
    setTotalDay(row.harcananToplamSure);
    return row;
  };

  return (
    <div className="row">
      <div className="col-md-12 col-xl-12 col-xxl-12">
        <FormikForm
          keyField={"timesForm"}
          endPointUrl="yonlendirilecek-talep/harcanan-sure-ekle"
          arrangeBeforePersist={arrangeBeforePersist}
          validationSchema={validationSchema}
          refreshList={() => setRefreshList(!refreshList)}
          okButtonText={t("tabs.ekle")}
          initialValues={initialValues}
          hideFooterHr
          resetAfterSubmit={true}
          disableButtons={props.disableButtons}
        >
          <Field
            name="harcananDate"
            label={t("tabs.tarih")}
            colNumber="6"
            component={ReactDatePicker}
            maxDate={new Date()}
          />
          <Field
            name="saatDakika"
            label={t("tabs.sureDakika")}
            colNumber="6"
            component={NumberInput}
          />
          <Field
            name="aciklama"
            label={t("tabs.aciklama")}
            colNumber="6"
            component={TextArea}
          />
        </FormikForm>
      </div>

      <div className="col-md-12">
        <ListComponent
          entityName=""
          endpoint="yonlendirilecek-talep/harcanan-sure-listele"
          keyField="id"
          refreshList={refreshList}
          mapDataBeforeList={mapDataBeforeList}
          totalDay={totalDay}
          customBody={{
            id: props.selectedRow.id,
          }}
          columns={[
            {
              dataField: "harcananDate",
              text: t("tabs.tarih"),
              formatter: formatShortDate,
              sort: true,
            },
            {
              dataField: "userDto.fullName",
              text: t("tabs.ilgiliKisi"),
              sort: true,
            },
            {
              dataField: "saatDakika",
              text: t("tabs.sure"),
              sort: true,
            },
            {
              dataField: "aciklama",
              text: t("tabs.aciklama"),
              sort: true,
            },
          ]}
          actionButtonsObject={{
            actions: [
              requestTo(ABT.DELETE, "/yonlendirilecek-talep/harcanan-sure-sil"),
            ],
            generator: DefaultActionButtonGenerator,
          }}
        />
      </div>
    </div>
  );
}
